function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "6D9AA139-715F-4DD5-83E1-5AC27A75E18F@1x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "tablet/dashboard-copy-7",
  transform: "translate(-298.000000, -1955.000000)"
}, React.createElement("g", {
  id: "people-copy-2",
  transform: "translate(289.000000, 1940.000000)"
}, React.createElement("g", {
  id: "research-(2)",
  transform: "translate(147.000000, 183.157258)"
}, React.createElement("g", {
  id: "Group-4"
})), React.createElement("ellipse", {
  id: "Oval-Copy-76",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 270.883065,
  cy: 187.602823,
  rx: 4.14919355,
  ry: 3.85282258
}), React.createElement("path", {
  d: "M182.564516,42.6774194 C189.766331,42.6774194 195.604839,36.8389113 195.604839,29.6370968 C195.604839,22.4352823 189.766331,16.5967742 182.564516,16.5967742 C175.362702,16.5967742 169.524194,22.4352823 169.524194,29.6370968 C169.524194,36.8389113 175.362702,42.6774194 182.564516,42.6774194 Z",
  id: "Stroke-9-Copy-2",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M270.883065,203.903226 C278.084879,203.903226 283.923387,198.064718 283.923387,190.862903 C283.923387,183.661089 278.084879,177.822581 270.883065,177.822581 C263.68125,177.822581 257.842742,183.661089 257.842742,190.862903 C257.842742,198.064718 263.68125,203.903226 270.883065,203.903226 Z",
  id: "Stroke-9-Copy-3",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M154.409274,184.342742 C166.357739,184.342742 176.044355,174.656126 176.044355,162.707661 C176.044355,150.759196 166.357739,141.072581 154.409274,141.072581 C142.460809,141.072581 132.774194,150.759196 132.774194,162.707661 C132.774194,174.656126 142.460809,184.342742 154.409274,184.342742 Z",
  id: "Stroke-9-Copy-9",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M119.733871,277.403226 C126.935685,277.403226 132.774194,271.564718 132.774194,264.362903 C132.774194,257.161089 126.935685,251.322581 119.733871,251.322581 C112.532056,251.322581 106.693548,257.161089 106.693548,264.362903 C106.693548,271.564718 112.532056,277.403226 119.733871,277.403226 Z",
  id: "Stroke-13-Copy-2",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M32.3044355,130.995968 C44.5809749,130.995968 54.5322581,121.043931 54.5322581,108.768145 C54.5322581,96.4916057 44.5809749,86.5403226 32.3044355,86.5403226 C20.0286495,86.5403226 10.0766129,96.4916057 10.0766129,108.768145 C10.0766129,121.043931 20.0286495,130.995968 32.3044355,130.995968 Z",
  id: "Stroke-15-Copy-2",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 161.225806,
  cy: 147,
  r: 71.7217742
}), React.createElement("path", {
  d: "M85.9923149,103.480174 C102.377223,110.750679 111.706702,119.126086 113.980752,128.606394 C117.391827,142.826857 111.382468,147.403739 117.391827,157.955009 C123.401185,168.506279 127.48425,176.332804 127.48425,184.685819",
  id: "Path-2",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  transform: "translate(106.738283, 144.082996) rotate(30.000000) translate(-106.738283, -144.082996) "
}), React.createElement("path", {
  d: "M165.05659,75.2782258 C161.159148,84.0751417 160.184788,90.5965064 162.133509,94.84232 C165.05659,101.21104 174.433406,112.092149 174.433406,117.71117 C174.433406,123.330192 178.537382,127.824578 182.564524,130.995969 C186.591665,134.167359 189.525563,138.431651 192.032896,143.604503 C194.540228,148.777356 200.991422,150.267289 200.991422,152.764482 C200.991422,155.261675 198.166363,167.534694 200.991422,170.834991 C203.816481,174.135287 211.377689,180.966401 212.695914,183.32163 C213.574731,184.891784 215.751719,186.756003 219.226878,188.914288 L224.548453,181.324012 C224.548453,172.392525 224.548453,165.976484 224.548453,162.075888 C224.548453,156.224994 225.757841,145.401113 219.226878,147.000001 C212.695914,148.598889 205.055613,147.000001 203.023518,147.000001 C200.991422,147.000001 191.408935,142.105782 194.540228,133.498782 C197.671521,124.891782 201.90404,119.923085 203.023518,117.71117 C204.142996,115.499255 206.22444,112.368638 207.532526,106.071575 C208.404583,101.873533 208.94314,97.8034831 209.148197,93.8614248",
  id: "Path-3",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M20.8350581,127.182514 C20.396397,126.17128 20.1532258,125.05557 20.1532258,123.883065 C20.1532258,119.299992 23.8685403,115.584677 28.4516129,115.584677 L36.75,115.584677 C41.3330726,115.584677 45.0483871,119.299992 45.0483871,123.883065 C45.0483871,125.05557 44.8052159,126.17128 44.3665548,127.182514 C41.0231723,129.587621 36.9696989,130.995968 32.6008065,130.995968 C28.231914,130.995968 24.1784406,129.587621 20.8350581,127.182514 Z",
  id: "Combined-Shape-Copy-4",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M264.20594,201.149707 C263.926232,200.544975 263.770161,199.871359 263.770161,199.16129 C263.770161,196.542392 265.893198,194.419355 268.512097,194.419355 L273.254032,194.419355 C275.872931,194.419355 277.995968,196.542392 277.995968,199.16129 C277.995968,199.871359 277.839897,200.544975 277.560189,201.149707 C275.658587,202.513179 273.359502,203.310484 270.883065,203.310484 C268.406627,203.310484 266.107542,202.513179 264.20594,201.149707 Z",
  id: "Combined-Shape-Copy-8",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M143.505891,180.70229 C143.084407,179.728636 142.850806,178.654703 142.850806,177.52621 C142.850806,173.106818 146.433431,169.524194 150.852823,169.524194 L157.965726,169.524194 C162.385117,169.524194 165.967742,173.106818 165.967742,177.52621 C165.967742,178.654703 165.734141,179.728636 165.312658,180.70229 C162.212305,182.998628 158.456545,184.342742 154.409274,184.342742 C150.362003,184.342742 146.606243,182.998628 143.505891,180.70229 Z",
  id: "Combined-Shape-Copy-17",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M175.887392,40.5166428 C175.607683,39.9119109 175.451613,39.2382945 175.451613,38.5282258 C175.451613,35.9093272 177.57465,33.7862903 180.193548,33.7862903 L184.935484,33.7862903 C187.554383,33.7862903 189.677419,35.9093272 189.677419,38.5282258 C189.677419,39.2382945 189.521349,39.9119109 189.24164,40.5166428 C187.340039,41.8801148 185.040954,42.6774194 182.564516,42.6774194 C180.088078,42.6774194 177.788994,41.8801148 175.887392,40.5166428 Z",
  id: "Combined-Shape-Copy-15",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M113.056747,275.242449 C112.777038,274.637717 112.620968,273.964101 112.620968,273.254032 C112.620968,270.635134 114.744005,268.512097 117.362903,268.512097 L122.104839,268.512097 C124.723737,268.512097 126.846774,270.635134 126.846774,273.254032 C126.846774,273.964101 126.690704,274.637717 126.410995,275.242449 C124.509394,276.605921 122.210309,277.403226 119.733871,277.403226 C117.257433,277.403226 114.958348,276.605921 113.056747,275.242449 Z",
  id: "Combined-Shape-Copy-16",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("ellipse", {
  id: "Oval-Copy-45",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 32.6008065,
  cy: 103.433468,
  rx: 7.11290323,
  ry: 6.81653226
}), React.createElement("ellipse", {
  id: "Oval-Copy-79",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 182.564516,
  cy: 26.9697581,
  rx: 4.14919355,
  ry: 3.85282258
}), React.createElement("ellipse", {
  id: "Oval-Copy-81",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 270.883065,
  cy: 188.195565,
  rx: 4.14919355,
  ry: 3.85282258
}), React.createElement("ellipse", {
  id: "Oval-Copy-82",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 154.409274,
  cy: 159.447581,
  rx: 6.81653226,
  ry: 6.52016129
}), React.createElement("ellipse", {
  id: "Oval-Copy-80",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 119.733871,
  cy: 261.695565,
  rx: 4.14919355,
  ry: 3.85282258
}))));

var SvgIconPeople = function SvgIconPeople(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "276px",
    height: "264px",
    viewBox: "0 0 276 264",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-people.b9df9119.svg";
export { ForwardRef as ReactComponent };